function SortList(sortArray) {
    for (let i = 0; i < sortArray.length; i++) {
        Object.defineProperty(this, sortArray[i].value, {value: sortArray[i]});
    }
}
export default SortList;